import { List } from "immutable";

import { nativeCommsBroadcastMessageTypes } from "../../nativeComms";
import nativeCommsMessageTypes from "../../nativeComms/nativeCommsMessageTypes";
import toMenuItemRecord from "./toMenuItemRecord";

export default (state, disabledItems) => {
  return List([
    {
      label: "Options...",
      messageType: nativeCommsMessageTypes.SHOW_PREFERENCES,
      shortcut: null,
      disabled: false,
      hasSeparator: true
    },
    {
      label: "Manage Backups...",
      messageType: nativeCommsMessageTypes.SHOW_BACKUP,
      shortcut: null,
      disabled: false,
      hasSeparator: false
    },
    {
      label: "Check for Updates...",
      messageType: nativeCommsBroadcastMessageTypes.CHECK_FOR_UPDATE,
      shortcut: null,
      disabled: false,
      hasSeparator: false
    },
    {
      label: "My Account...",
      messageType: nativeCommsBroadcastMessageTypes.SHOW_REGISTRATION_MODAL,
      shortcut: null,
      disabled: false,
      hasSeparator: false
    }
  ]).map(item => toMenuItemRecord(item, disabledItems));
};
